import React from 'react';
import PropTypes from 'prop-types';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import UserMenu from '../Users/UserMenu';
import Typography from '@material-ui/core/Typography';
import T from 'i18n-react';
import { makeStyles } from '@material-ui/core/styles';
import { makeContainerStyles } from '../styles';
import MuiLink from '@material-ui/core/Link';
import { USER_PAYMENT_HISTORY } from '../routing';
import moment from 'moment/moment';
import ProfileChangeRequest from '../../../components/front/User/ProfileChangeRequest';

const useStyles = makeStyles((theme) => ({
  root: {
    ...makeContainerStyles(theme),
    margin: 'auto',
    minHeight: '70vh',
  },
  title: {
    marginBottom: theme.spacing(5),

    fontSize: '1.5rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '2rem',
    },
  },
  paymentAmountContainer: {
    fontWeight: 'bold',
    backgroundColor: theme.props.backgroundColor.primary.main,
    borderRadius: 10,
    border: `solid thin ${theme.props.border.secondary.main}`,
    marginBottom: theme.spacing(4),
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(4, 4, 2),
    },
  },
  totalAmount: {
    fontSize: '1.5rem',
  },
  fontSmall: {
    fontSize: theme.typography.pxToRem(14),
  },
}));

const Payment = ({ totalAmount, date, profileChangeRequest }) => {
  const classes = useStyles();

  return (
    <Container maxWidth="lg" className={classes.root}>
      <Grid container justify="center">
        <Grid item xs={12} sm={4}>
          <Hidden xsDown implementation="css">
            <UserMenu />
          </Hidden>
        </Grid>
        <Grid item xs={12} sm={8} container spacing={3}>
          <Grid item xs={12}>
            <Typography className={classes.title} variant="h4">
              {T.translate('user.titles.payments')}
            </Typography>
          </Grid>
          {profileChangeRequest && (
            <Grid item xs={12} container spacing={1}>
              <ProfileChangeRequest
                profileChangeRequest={profileChangeRequest}
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <Grid
              item
              xs={12}
              container
              spacing={1}
              className={classes.paymentAmountContainer}
            >
              <Grid item xs={12} sm={4} container alignItems="center">
                <span>
                  {T.translate('user.payments.amountByMonth', {
                    month: moment(date).format('M'),
                  })}
                </span>
              </Grid>
              <Grid item xs={12} sm={8}>
                <span className={classes.totalAmount}>
                  ¥ {Math.floor(totalAmount).toLocaleString()}
                </span>
              </Grid>
              <Grid item xs={12}>
                <Typography color="textSecondary" className={classes.fontSmall}>
                  {T.translate('user.payments.updateTiming')}
                </Typography>
                <div style={{ textAlign: 'right' }}>
                  <MuiLink
                    href={USER_PAYMENT_HISTORY}
                    className={classes.fontSmall}
                  >
                    {T.translate('user.payments.seeHistory')}
                  </MuiLink>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

Payment.propTypes = {
  totalAmount: PropTypes.number,
  profileChangeRequest: PropTypes.shape({
    comment: PropTypes.string,
    changeRequestProfileItems: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        kind: PropTypes.string,
        name: PropTypes.string,
        profilePath: PropTypes.string,
      }),
    ),
  }),
};

export default Payment;
